const identicalCharactersRegex = /^(.)\1{1,}$/;

const isSequential = (giin) => {
  if (giin.length === 1) {
    return false;
  }

  for (let i = 0; i < giin.length - 1; i += 1) {
    if (i < giin.length - 1) {
      let currentNumber = parseInt(giin[i], 10);
      const nextNumber = parseInt(giin[i + 1], 10);
      currentNumber += 1;
      if (currentNumber !== nextNumber) {
        return false;
      }
    }
  }
  return true;
};

// eslint-disable-next-line import/prefer-default-export
export const getGiinErrorMessage = (fullGiinEntry, fieldLength, isRequired) => {
  let customError = '';

  if (fullGiinEntry === '' && isRequired) {
    customError = 'Please provide a GIIN';
  } else if (fullGiinEntry !== '') {
    if (fieldLength && fullGiinEntry.length !== fieldLength) {
      customError = `A GIIN must contain ${ fieldLength } characters`;
    } else if (identicalCharactersRegex.test(fullGiinEntry)) {
      customError = 'A GIIN cannot be composed of identical characters.';
    } else if (isSequential(fullGiinEntry)) {
      customError = 'A GIIN cannot be composed of sequential numbers.';
    } else {
      return false;
    }
  }

  return customError;
};
